// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pNmL4","placeholdersHeader":"styles_placeholdersHeader__2rYqQ","editorStyle":"styles_editorStyle__xZyVV","placeholdersBox":"styles_placeholdersBox__3l4vd"};